/*
  Product gallery: thumbnail rail + prev/next arrows over a single stage.
  Slides cross-fade; keyboard arrows work once the stage has focus.
*/
if (!customElements.get('brand-gallery')) {
  customElements.define(
    'brand-gallery',
    class BrandGallery extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.brand-gallery__slide'));
        this.thumbs = Array.from(this.querySelectorAll('.brand-gallery__thumb'));
        if (this.slides.length < 2) return;

        this.index = 0;
        this.stage = this.querySelector('.brand-gallery__stage');

        this.querySelector('.brand-gallery__arrow--prev')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('.brand-gallery__arrow--next')?.addEventListener('click', () => this.go(this.index + 1));

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.go(parseInt(thumb.dataset.index, 10)));
        });

        this.stage?.setAttribute('tabindex', '0');
        this.stage?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index - 1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(this.index + 1);
          }
        });
      }

      go(next) {
        const total = this.slides.length;
        const target = ((next % total) + total) % total;
        if (target === this.index) return;

        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.slides[target].classList.add('is-active');
        this.slides[target].removeAttribute('aria-hidden');

        if (this.thumbs.length) {
          this.thumbs[this.index]?.classList.remove('is-active');
          this.thumbs[this.index]?.removeAttribute('aria-current');
          this.thumbs[target]?.classList.add('is-active');
          this.thumbs[target]?.setAttribute('aria-current', 'true');
          this.thumbs[target]?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }

        this.index = target;
      }
    }
  );
}
